<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.projectOverView }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.projectOverView }}</div> -->
        <!-- <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }}
        </div> -->

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph1  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph2  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph3  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph4  }}
        </div>
        <div class="static-content-paragraph">
          <ol style="list-style-type: none;padding: 0;">
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_1  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_2  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_3  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_4  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_5  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_6  }}</li>
          	<li>{{ activeLanguageTranslations?.mthdParagraph4_7  }}</li>
          </ol>
        </div>


        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.mthdParagraph5 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph6  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph7  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph8  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph9  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph10 }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.mthdParagraph11 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph11_1  }}
        </div>

        <div class="static-content-paragraph">
          <ol style="list-style-type: none;padding: 0;">
            <li>{{ activeLanguageTranslations?.mthdParagraph11_2  }}</li>
            <li>{{ activeLanguageTranslations?.mthdParagraph12  }}</li>
            <li>{{ activeLanguageTranslations?.mthdParagraph13  }}</li>
          </ol>
          
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph14  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.mthdParagraph15  }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.mthdParagraph16 }}
        </div>

        <div class="static-content-paragraph" [class.is-mobile]="isHandsetPortrait">
        	<table class="mat-mdc-table mdc-data-table__table cdk-table sggs-table mat-elevation-z0 demo-table">
        		<thead>


        			<tr class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row ng-star-inserted">
        				<th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-word mat-column-word firstHeading ng-star-inserted">{{ activeLanguageTranslations?.mthdParagraph17_1 }}</th>
        				<th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-word mat-column-word secondHeading ng-star-inserted">{{ activeLanguageTranslations?.mthdParagraph17_2 }}</th>
        			</tr>	


        		</thead>
        		<tbody>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph18_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph18_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph19_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph19_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph20_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph20_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph21_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph21_2 }}</td>
        			</tr>

        			<tr>
        				<td><i>{{ activeLanguageTranslations?.mthdParagraph22_1 }}</i></td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph22_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph23_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph23_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph24_1 }}</td>
        				<td>
        					{{ activeLanguageTranslations?.mthdParagraph24_2 }}
        					<br>
        					{{ activeLanguageTranslations?.mthdParagraph24_3 }}
        					<br>
        					<ul style="list-style-type: none;">
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_1 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_2 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_3 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_4 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_5 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_6 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_7 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_8 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_9 }}</li>
        						<li>{{ activeLanguageTranslations?.mthdParagraph24_3_10 }}</li>
        					</ul>
        					{{ activeLanguageTranslations?.mthdParagraph24_4 }}
        				</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph25_1 }}</td>
        				<td>
        					{{ activeLanguageTranslations?.mthdParagraph25_2 }} <br><br>
        					{{ activeLanguageTranslations?.mthdParagraph25_3 }} <br><br>
        					{{ activeLanguageTranslations?.mthdParagraph25_4 }} <br><br>
        					{{ activeLanguageTranslations?.mthdParagraph25_5 }}
        				</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph26_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph26_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph27_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph27_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph28_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph28_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph29_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph29_2 }}</td>
        			</tr>

        			<tr>
        				<td>{{ activeLanguageTranslations?.mthdParagraph30_1 }}</td>
        				<td>{{ activeLanguageTranslations?.mthdParagraph30_2 }}</td>
        			</tr>


        		</tbody>
        		<tfoot></tfoot>
        	</table>
        </div> 

        <div class="padded-content-wrapper1" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">
          Transcription Guidelines
        </div>
        <div class="static-content-paragraph">
          Transcription or transliteration is the practice of representing a written letter or a word from one script to another. It is also the system of rules for that practice. Transcription and transliteration attempt to accurately capture the sound values across writing systems.
        </div>
        <div class="static-content-paragraph">
          Transliteration attempts to be exact. With the help of transliteration, an informed reader should be able to recreate the original spelling of the transliterated words. Transliteration is commonly employed in situations where high precision is required. It is necessary when using words or concepts expressed in a language with a script other than one’s own.
        </div>
        <div class="static-content-paragraph">
          Transcription is slightly different in that it takes into account the sound values represented by the writing systems. Transcription assists in speech and pronunciation rather than the exact written representation. For example:
        </div>
        <div class="static-content-paragraph">
          <ul style="list-style-type: disc">
            <li class="inter-font"><b>ਪਰਮਦਭੁਤੰ</b> ‒ paramadabhutaṅa (transliteration)</li>
            <li class="inter-font"><b>ਪਰਮਦਭੁਤੰ</b> ‒ parmadbhutaṅ (transcription)</li>
            <li class="inter-font"><b>Psychology</b> - ਪਸਯਕੋਲੋਜੀ (transliteration)</li>
            <li class="inter-font"><b>Psychology</b> - ਸਾਈਕੌਲੋਜੀ (transcription)</li>
          </ul>
        </div>
        <div class="static-content-paragraph">
          If relations between letters and sounds are similar in both languages,
          transliteration may be nearly identical to its transcription.
          Transcription has a superficial attraction in that it is generally
          more readable, primarily because it expresses sounds associated with
          one script using another script.
        </div>
        <div class="static-content-paragraph">
          In regards to Gurmukhi, transcription proves utilitarian because the
          script is highly phonetic. Because this project concerns the spoken
          aspects of the script, transcription is utilized throughout this
          volume. When writing proper nouns outside of the context of line
          meanings and footnotes, common spellings will be used instead of
          transcription-accurate spellings.
        </div>
        <div class="static-content-paragraph">
          <span class="left-padding"> <b>Ex:</b> Duni Cand → Duni Chand</span> <br />
          <span class="left-padding">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Shekh Ibrahim → Sheikh Ibrahim</span>
        </div>
        <div class="static-content-paragraph">
          Considering that the pronunciation of Guru Granth Sahib is closely
          related to its interpretation, an accurate and standardized
          transcription system assumes a very important role since meanings tend
          to change with even a slight variation in tone or nasalization. An
          accurate transcription would thus supplement the correct articulation
          of phones.
        </div>
        <div class="static-content-paragraph">
          Developing a standardized transcription would aid both the Sikh Diaspora and Western scholars who wish to grasp the language of Guru Granth Sahib better. A universally accepted system will go a long way in advancing the language and its understanding. Due to shortcomings in the English language in general, and the Roman script in particular, it has proved challenging to develop a technique for transcription with the capacity to consistently and accurately transfer text from Gurmukhi characters to Roman characters. Numerous attempts have been made in the past, and gratefully, modern linguistic standards and thorough research have finally made Gurmukhi-Roman transcription a reality.
        </div>
        <div class="static-content-paragraph">
          A majority of the characters used to transcribe Gurmukhi into English
          have been derived from a universally recognized system of linguistics.
          For those Gurmukhi letters lacking an equivalent representation in the
          Roman alphabet, a symbol comparable to a character with an associable
          sound has been generated to represent those alphabets. As each
          Gurmukhi letter represents a unique audible sound, it has been
          assigned its own symbol for transcription into the Roman script.
        </div>

        <div class="static-content-heading-wrapper">
          Transcription GuideLines
        </div>

        <div class="static-content-paragraph">
          Since speech precedes writing, identifying speech sounds is vital for establishing the correct pronunciation of a word. The sound being produced while uttering a word is more important than the rules in establishing the correct transcription output. Hence, the pronunciation precedes the transcription rules. Transcription rules only help in understanding and establishing commonly identifiable patterns.
        </div>
        <div class="table-responsive">

          <table class="sggs-table mat-elevation-z0 demo-table table inter-font">
            <thead>
              <tr class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row ng-star-inserted"> 
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted"></th>
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted">C1</th>
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted">C2</th>
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted">C3</th>
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted">C4</th>
                <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell sggs-table-row-outline sggs-table-header cdk-column-c0 mat-column-c0 ng-star-inserted">C5</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">R1</td>
                <td colspan="3">Vowels</td>
                <td rowspan="2">ਸ (s)</td>
                <td rowspan="2">ਹ (h)</td>
              </tr>
              <tr>
                <td><em>ੳ (-)</em></td>
                <td><em>ਅ (a)</em></td>
                <td><em>ੲ (-)</em></td>
              </tr>
              <tr>
                <td>R2</td>
                <td>ਕ (k)</td>
                <td>ਖ (kh)</td>
                <td>ਗ (g)</td>
                <td>ਘ (gh)</td>
                <td>ਙ (ṅ)</td>
              </tr>
              <tr>
                <td>R3</td>
                <td>ਚ (c)</td>
                <td>ਛ (ch)</td>
                <td>ਜ (j)</td>
                <td>ਝ (jh)</td>
                <td>ਞ (ñ)</td>
              </tr>
              <tr>
                <td>R4</td>
                <td>ਟ (ṭ)</td>
                <td>ਠ (ṭh)</td>
                <td>ਡ (ḍ)</td>
                <td>ਢ (ḍh)</td>
                <td>ਣ (ṇ)</td>
              </tr>
              <tr>
                <td>R5</td>
                <td>ਤ (t)</td>
                <td>ਥ (th)</td>
                <td>ਦ (d)</td>
                <td>ਧ (dh)</td>
                <td>ਨ (n)</td>
              </tr>
              <tr>
                <td>R6</td>
                <td>ਪ (p)</td>
                <td>ਫ (ph)</td>
                <td>ਬ (b)</td>
                <td>ਭ (bh)</td>
                <td>ਮ (m)</td>
              </tr>
              <tr>
                <td>R7</td>
                <td>ਯ (y)</td>
                <td>ਰ (r)</td>
                <td>ਲ (l)</td>
                <td>ਵ (v)</td>
                <td>ੜ (ṛ)</td>
              </tr>
              <!-- <tr>
                <td colspan="6"><b>Gurmukhi Consonants</b></td>
              </tr> -->
            </tbody>
          </table>


          <!-- <table
          mat-table
          [dataSource]="dataSource"
          class="sggs-table mat-elevation-z0 demo-table table"
        >
          <ng-container
            *ngFor="let column of columns; let i = index"
            [matColumnDef]="column.columnDef"
          >
            
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sggs-table-row-outline sggs-table-header"
            >
              {{ column.header }}
            </th>
            <td 
              [class.no-border-bottom]="
                column.cell(row) === 'R1' ||
                column.cell(row) === 'ਸ (s)' ||
                column.cell(row) === 'ਙ (ṅ)'
              "
              mat-cell
              *matCellDef="let row"
              class="sggs-table-row-outline"
            >
              {{ column.cell(row) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table> -->
        </div>
       

        <div class="static-content-heading-wrapper">Consonants</div>
        <div class="static-content-paragraph">

          <ol>
            <li>The consonants begin from s (ਸ), and continue through ṛ (ੜ).</li>
            <li>
            In pronunciation, a consonant that stands independent of a vowel character will be followed by an implicit “a” (muktā).
            <ol type="a">
              <li>
                a. The above statement is only true for consonants devoid of vowel characters. However, if the consonant is the final letter of the word, then the implicit “a” is omitted in transcription.<br>
                <b>Example 1:</b> <span class="inter-font">
                  ਨਦਰ (na + da + ra = nadar)
                </span><br>
                <b>Example 2:</b> 
                <span class="inter-font">
                  ਸਤ (sa + ta = sat)
                </span>
              </li>
              <li>
                The implicit “a” is applicable at the end of a single character word.<br>
                <b>Example 1:</b><span class="inter-font">ਨ (na)</span> <br>
                <b>Example 2:</b><span class="inter-font">ਤ (ta)</span> 
                </li>
                </ol>
              </li>
              <li>
                There are instances where the implicit “a” is overlooked. In these cases, the “a” can be omitted as it aids in pronunciation. The inclusion of the implicit “a” is not inaccurate, but more functional.<br>
                <b>Example 1:</b> <span class="inter-font">ਦਰਸਨ (da + ra + sa + na = darsan)</span><br>
                <b>Example 2:</b> <span class="inter-font">ਕਰਤਾ (ka + ra + tā = kartā)</span>
              </li>
              <li>
                When a consonant with a short “a” is followed by a vowel character supported by a vowel base (specifically ਉ and ਇ), then the vowel symbol will be indicated by a corresponding dieresis (ï or ü) vowel.<br>
                <b>Example 1:</b> <span class="inter-font">ਸਉ (sa + u = saü)</span><br>
                <b>Example 2:</b> <span class="inter-font">ਗਇ (ga + i = gaï)</span>
              </li>
            </ol>

          <div class="table-responsive inter-font">
              <table class="table table-bordered table-hover tblmargin statisContentTable">
                <thead>
                  <tr>
                    <th class="heading">Vowels</th>
                    <td>ਅ</td>
                    <td>ਾ</td>
                    <td>ਿ</td>
                    <td>ੀ</td>
                    <td>ੁ</td>
                    <td>ੂ</td>
                    <td>ੇ</td>
                    <td>ੈ</td>
                    <td>ੋ</td>
                    <td>ੌ</td>
                  </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="heading">Transcription</th>
                  <td>a</td>
                  <td>ā</td>
                  <td>i</td>
                  <td>ī</td>
                  <td>u</td>
                  <td>ū</td>
                  <td>e</td>
                  <td>ai</td>
                  <td>o</td>
                  <td>au</td>
                </tr>
                <!-- <tr>
                <td colspan="11"><b>Gurmukhi Vowels</b></td>
                </tr> -->
              </tbody>
            </table>

            <!-- <table mat-table [dataSource]="dataSourceConsonants" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of consonantsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" [class.no-left-border]="row.id === 2"  class="sggs-table-row-outline">
                {{column.cell(row)}} 
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedConsonantsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedConsonantsColumns;"></tr>
            </table> -->

          </div>
        </div>

        <div class="static-content-paragraph"></div>

        <div class="static-content-heading-wrapper">Vowels</div>
        <div class="static-content-paragraph">

          <ol>
            <li>There are three vowel bases (ੳ, ਅ, ੲ).</li>
            <li>In addition to the implicit “a” that follows consonants independent of vowels, there are ten vowel characters (see vowel chart).</li>
            <li>
            Of the three vowel bases, only ਅ can stand independent of another vowel character.<br>
            <b>Example 1:</b><span class="inter-font">ਅਗਨ (a + ga + na = agan)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਅਕਾਲ (a + kā + la = akāl)</span> 
            </li>
            <li>
            If a vowel character is directly followed by another vowel base and character, then the implicit “a” will be omitted.<br>
            <b>Example 1:</b> <span class="inter-font">ਜਾਇ (jā + i = jāi)</span><br>
            <b>Example 2:</b> <span class="inter-font">ਕੀਓ (kī + o = kīo)</span>
            </li>
            <li>
            If a vowel character combines with a vowel base to produce the first letter in the word, there will be no “a” preceding the vowel.<br>
            <b>Example 1:</b> <span class="inter-font">ਊਪਰਹੁ (ū + pa + ra + hu = ūparahu)</span><br>
            <b>Example 2:</b> <span class="inter-font">ਆਸਣੁ (ā + sa + ṇu = āsaṇu)</span>
            </li>
            <li>
            If a vowel character is present with a consonant rather than a vowel base, then there will be no “a” between the consonant and the vowel.<br>
            <b>Example 1:</b> <span class="inter-font">ਸੂਰਾ (sū + rā = sūrā)</span><br>
            <b>Example 2:</b> <span class="inter-font">ਮੋਹਿ (mo + hi = mohi)</span>
            </li>
          </ol>

        </div>

        <div class="static-content-heading-wrapper">Ṭippi (ੰ) <!-- ṬIPPĪ(<img src="/assets/images/tippi.svg" style="height:19px;">) --></div>
        <div class="static-content-paragraph">

          <ol>
            <li>
            When a ṭippī is representing one of the five sounds (ṇ, ṅ, ñ, n, m), it will not be followed by an implicit “a.”<br>
            <b>Example 1:</b><span class="inter-font">ਖੰਡ (kha + ṇ + ḍa = khaṇḍ)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਚੰਗਾ (ca + ṅ + gā = caṅgā)</span> 
            </li>
            <li>
            If a ṭippī is representing one of the five sounds (ṇ, ṅ, ñ, n, m), and the letter following the ṭippī falls within rows 2-6 (consonant chart), then the ṭippī will make the sound of the last letter in the corresponding row.<br>
            <b>Example 1:</b><span class="inter-font">ਅੰਤ (a + n + ta = ant)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਸੰਗਤਿ (sa + ṅ + ga + ti = saṅgati)</span> 
            <ol type="a">
            <li>
            If a letter following the ṭippī falls in row 1 or 7 (consonant chart), then the ṭippī predominantly makes a “n” sound (consonant nasalization) and occasionally a “ṁ” sound (vowel nasalization).<br>
            <b>Example 1:</b> <span class="inter-font">ਸੰਸਾ (sa + n + sā = sansā)</span><br>
            <b>Example 2:</b> <span class="inter-font">ਮੁੰਲਾ (mu + ṁ + lā = muṁlā)</span>
            </li>
            <li>
            When a ṭippī represents one of the five sounds (ṇ, ṅ, ñ, n, m), and the letter emphasized by the ṭippī represents the same sound (ṇ, ṅ, ñ, n, m), then it will create a double sound (compound), and should be transcribed accordingly.<br>
            <b>Example 1:</b> <span class="inter-font">ਅੰਮ੍ਰਿਤ (a + mma + ri + ta = ammrit)</span><br>
            <b>Example 2:</b> <span class="inter-font">ਮੰਨੀਐ (ma + nnī + ai = mannīai)</span>
            </li>
            </ol>
            </li>
            <li>
            If a ṭippī is at the end of the word, and therefore unsupported by another consonant, then the default sound is “aṅ.”<br>
            Example 1:<span class="inter-font">ਸੈਭੰ (sai + bhaṅ = saibhaṅ)</span> <br>
            Example 2: <span class="inter-font">ਕਰਮੰ (ka + ra + maṅ = karmaṅ)</span>
            <ol type="a">
            <li>
            If a ṭippī concludes a term in a compound word, then the ṭippī will create the “ṅ” sound.<br>
            <b>Example 1:</b><span class="inter-font">ਅਹੰਕਾਰ (a + ha + ṅ + kā + ra = ahaṅkār)</span><br>
            <b>Example 2:</b><span class="inter-font"> ਅਹੰਬੁਧਿ (a + ha + ṅ + bu + dhi = ahaṅbudhi)</span>
            </li>
            </ol>
            </li>
            <li>
            All vowel nasalization are denoted by “ṁ.”<br>
            <b>Example:</b><span class="inter-font">ਤੂੰ (tū + ṁ = tūṁ)</span> 
            </li>
            <li>The ṭippī has two possible connotations. It commonly symbolizes an additional sound incorporating one of five characters (ṇ, ṅ, ñ, n, m), and sometimes denotes a nasalization (ṁ). Identification of correct usage in various instances can only be determined with the knowledge of the language.</li>
          </ol>
        </div>

        <div class="static-content-heading-wrapper">Bindi (ਂ) <!-- BINDĪ(<img src="/assets/images/bindi.svg" style="height:19px;">) --></div>
        <div class="static-content-paragraph">
          <ol>
            <li>The bindī can play two different roles. Predominantly, it calls for vowel nasalization (and in a few instances, consonant nasalization) that produces a “ṁ” sound. It occasionally forms a “n” sound. One can know the role of bindī only with an understanding of the language.</li>
            <li>
            When creating a “n” sound, there will be no implicit “a” sound following the “n” sound.<br>
            <b>Example:</b><span class="inter-font">ਸਾਂਤਿ (sā + ṁ + ti = sāṁti)</span> 
            </li>
            <li>
            All vowel nasalizations are denoted by “ṁ.”<br>
            <b>Example 1:</b><span class="inter-font">ਤੂਹੈਂ (tū + ha + aiṁ = tūhaiṁ)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਹਾਂ (ha + āṁ = hāṁ)</span> 
            </li>
          </ol>
        </div>
        <div class="static-content-heading-wrapper">Visarg ( ਃ) <!-- (<img src="/assets/images/visarg.svg" style="height:19px;">) --></div>
        <div class="static-content-paragraph">
          <ol>
            <li>
            The Visarg is represented by a “ḥ.” It is pronounced as a softer “h,” and an implicit “a” precedes the “ḥ.”<br>
            <b>Example 1:</b><span class="inter-font">ਦ੍ਰਿੜੰਤਣਃ (dri + ṛa + n + ta + ṇa + ḥa = driṛantaṇaḥ)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਲਿਖੵਣਃ (li + kha + ya + ṇa + ḥa = likhyaṇaḥ)</span> 
            </li>
          </ol>
        </div>
        <div class="static-content-heading-wrapper">Subscripts</div>
        <div class="static-content-paragraph">

          <ol class="inter-li">
            <li>There are eight subscripts used within Guru Granth Sahib.</li>
            <li>The subscript appears below the consonant.</li>
            <li>
            The subscript is pronounced directly after the consonant above it; there is no implicit “a” between the two.<br>
            <b>Example 1:</b> <img alt="ascaraj image" src="/assets/images/ascaraj.jpg" style="vertical-align: bottom;"> (ascaraj)<br>
            <b>Example 2:</b> <img alt="dastagīrī image" src="/assets/images/dastagiri.jpg" style="vertical-align: bottom;"> (dastagīrī)
            </li>
            <li>
            If a vowel supports a consonant and the subscript, then the subscript will follow the consonant but precede the vowel in pronunciation.<br>
            <b>Example 1:</b> <img alt="bisṭā image" src="/assets/images/bista.jpg" style="vertical-align: bottom;"> (bisṭā)<br>
            <b>Example 2:</b> <img alt="snehaṅ image" src="/assets/images/snehan.jpg" style="vertical-align: bottom;"> (snehaṅ)
            </li>
          </ol>
          <div class="table-responsive subscript">
            <img alt="Transcription Table Image" style="width:100%;" src="/assets/images/transcription_table.png" class="transcriptiontbImg">
            
            <!-- <table class="sggs-table mat-elevation-z0 demo-table table Subscript">
              <thead>
                <tr class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row ng-star-inserted">
                  <th>Subscript</th>
                  <th>Origin</th>
                  <th>Example</th>
                  <th>Transcription</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>a</td>
                  <td>a</td>
                  <td>a</td>
                  <td>varhiā</td>
                </tr>
                <tr>
                  <td>b</td>
                  <td>b</td>
                  <td>b</td>
                  <td>ascaraj</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>bisṭā</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>ast</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>krisn</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>dukhyaṅ</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>prā</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table> -->
            <!-- <table mat-table [dataSource]="subscriptsDataSource" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of subscriptsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" class="sggs-table-row-outline">
                {{column.cell(row)}}
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedSubscriptsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedSubscriptsColumns;"></tr>
            </table> -->
          </div>

        </div>
        <div class="static-content-heading-wrapper">Halant-Like Symbol (ੑ ) <!-- HALANT-LIKE SYMBOL(<img src="/assets/images/halant.svg" style="height:24px;">) --></div>
        <div class="static-content-paragraph">
          <ol>
            <li>
            Appearance of this symbol in Guru Granth Sahib is represented through the same in the Roman script as well.<br>
            <b>Example 1:</b> <span class="inter-font">ਜਿਨੑੀ (ji + n̖ī = jin̖ī)</span><br>
            <b>Example 2:</b><span class="inter-font">ਧਿਆਵਨਿੑ (dhi + ā + va + n̖i = dhiāvan̖i)</span> 
            </li>
          </ol>
        </div>
        <div class="static-content-heading-wrapper">Prolongation (ਅ)</div>
        <div class="static-content-paragraph">
          <ol>
            <li>
            When appearing at the end of a word and directly following a vowel character, the A represents a prolongation of the sound preceding it.<br>
            <b>Example 1:</b><span class="inter-font">ਜੀਅ (jī + a = jīa)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਲੋਅ (lo + a = loa)</span> 
            </li>
          </ol>
          <div class="table-responsive inter-font">
            <br />
            <b>Cardinal Numbers</b>

            <table class="table table-bordered table-hover tblmargin statisContentTable">
              <thead>
                <tr>
                  <th class="heading">Roman</th>
                  <td>0</td>
                  <td>1</td>
                  <td>2</td>
                  <td>3</td>
                  <td>4</td>
                  <td>5</td>
                  <td>6</td>
                  <td>7</td>
                  <td>8</td>
                  <td>9</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="heading">Gurmukhi</th>
                  <td>੦</td>
                  <td>੧</td>
                  <td>੨</td>
                  <td>੩</td>
                  <td>੪</td>
                  <td>੫</td>
                  <td>੬</td>
                  <td>੭</td>
                  <td>੮</td>
                  <td>੯</td>
                </tr>
              </tbody>
            </table>
            
            <!-- <table mat-table [dataSource]="cardinalsDataSource" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of cardinalsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" class="sggs-table-row-outline">
                {{column.cell(row)}}
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedCardinalsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedCardinalsColumns;"></tr>
            </table> -->

          </div>  


        </div>
        <div class="static-content-heading-wrapper">Numerals</div>
        <div class="static-content-paragraph">
          <ol>
            <li>
            Gurmukhi numerals are transcribed through the respective Roman digits as per the table above. However, a number may be properly spelt in the transcription if the original in the Gurmukhi script indicates so.<br>
            <b>Example 1:</b><span class="inter-font"> ੧ (1)</span> <br>
            <b>Example 2:</b><span class="inter-font">ਇਕੁ (i + ku = iku)</span> 
            </li>
          </ol>
        </div>
        <div class="static-content-heading-wrapper">Adoptions</div>
        <div class="static-content-paragraph">
          <ol>
            <li>
            <b>Farsi</b>
            <ol type="a">
            <li>
            If an equivalent sound for a Farsi inspired letter exists in the Roman script, then that Roman letter is used in the transcription.<br>
            <b>Example 1:</b><span class="inter-font">ਫ਼ (f)</span>  <br>
            <b>Example 2:</b><span class="inter-font">ਜ਼ (z)</span> 
            </li>
            <li>
            If there is no corresponding sound already inscribed in the Roman alphabet, then the sound will be indicated with a line underneath the corresponding Roman letters.<br>
            <b>Example 1:</b><span class="inter-font"> ਗ਼ (gh)</span><br>
            <b>Example 2:</b><span class="inter-font"> ਖ਼ (kh)</span>
            </li>
            <li>The contemporary version of the Gurmukhi script has adopted five new sounds that are indicated with a dot under the corresponding Gurmukhi letter: ਗ਼ (gh), ਜ਼ (z), ਫ਼ (f), ਖ਼ (kh), ਸ਼ (sh).</li>
            <li>Beside these five, the Gurmukhi script has later adopted another sound represented by ਲ਼ (ḷ).</li>
            </ol>
            </li>
            <li>
            <b>Adhak (ੱ )</b>
            <ol type="a">
            <li>The adhak conveys which syllable should be stressed. Though used within secondary writings of the Sikhs, the adhak came into use after the Guru Granth Sahib was compiled. Therefore, it does not appear within the text of the Guru Granth Sahib.</li>
            <li>
            Gurmukhi characters emphasized by the adhak will be written twice in the Roman script.<br>
            <b>Example:</b><span class="inter-font">ਵਡਮੁੱਲਾ (va + ḍa + mu + llā = vaḍmullā)</span> 
            </li>
            <li>
            If more than one Roman alphabet is utilized to represent a Gurmukhi letter that is emphasized by the adhak, then only the first letter will be doubled.<br>
            <b>Example:</b> <span class="inter-font">ਭੱਠੀ (bha + ṭṭhī = bhaṭṭhī)</span>
            </li>
            </ol>
            </li>
          </ol>
        </div>

      </div>	

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
